import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
// A bold positioning statement that reframes what Giga is for.
// Redesigned as a two-column split with a "calm" visual (a single, clean
// notification card) to contrast with the "chaos" visual in the preceding section.
// The top border is intentionally omitted so it flows seamlessly from the
// TwelveTabProblem section above it on the same cream stage.
export function WorkYouCantGetTo() {
  return <section className="relative w-full overflow-hidden bg-[#FAF8F4] py-24 md:py-32" data-id="element-3326">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-3327">
        {/* Visual (Left) - Calm */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative h-[360px] md:h-[440px] w-full flex items-center justify-center order-2 md:order-1" data-id="element-3328">
          {/* Soft background glow */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(234,88,12,0.06)_0%,transparent_70%)]" data-id="element-3329" />

          {/* Single Calm Notification Card */}
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 w-full max-w-[320px] bg-white rounded-2xl shadow-[0_20px_40px_-15px_rgba(0,0,0,0.05)] border border-neutral-200/60 p-6" data-id="element-3330">
            <div className="flex items-start gap-4" data-id="element-3331">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#FFF1E8] text-[#EA580C] shrink-0" data-id="element-3332">
                <Sparkles size={18} data-id="element-3333" />
              </div>
              <div className="flex-1 pt-1" data-id="element-3334">
                <p className="text-sm font-semibold text-[#2B211A] leading-snug mb-1" data-id="element-3335">
                  Found 3 overdue invoices
                </p>
                <p className="text-xs text-neutral-500 mb-4" data-id="element-3336">
                  Drafted and sent follow-up emails to clients.
                </p>
                <div className="flex items-center gap-1.5 text-xs font-bold text-green-600 bg-green-50 w-fit px-2 py-1 rounded-md" data-id="element-3337">
                  <CheckCircle2 size={14} data-id="element-3338" />
                  <span data-id="element-3339">Handled</span>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Text (Right) */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative z-10 max-w-xl order-1 md:order-2" data-id="element-3340">
          <h2 className="text-3xl md:text-5xl font-title font-medium leading-[1.1] tracking-tight text-[#2B211A]" data-id="element-3341">
            You didn't ask. Giga noticed.
          </h2>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-neutral-500 font-medium leading-relaxed" data-id="element-3342">
            Other AI tools stop at answers. Giga goes further.
          </p>
        </motion.div>
      </div>
    </section>;
}